(() => {
const root = document.querySelector('.sg-home');
if (!root) return;
const countEl = root.querySelector('[data-sg-count]');
const searchCount = root.querySelector('[data-sg-search-count]');
const counter = root.querySelector('.sg-counter');
let total = null;
let displayed = 0;
let frame;
let inView = false;
let loading = false;
const format = value => value.toLocaleString();
const animate = (from, to) => {
  if (!countEl) return;
  cancelAnimationFrame(frame);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const start = performance.now();
  const step = now => {
    const progress = reduced ? 1 : Math.min(1, (now - start) / 1200);
    displayed = Math.round(from + (to - from) * (1 - Math.pow(1 - progress, 3)));
    countEl.textContent = format(displayed);
    if (progress < 1) frame = requestAnimationFrame(step);
  };
  frame = requestAnimationFrame(step);
};
const refresh = async () => {
  if (loading || document.hidden || !root.dataset.inventoryUrl) return;
  loading = true;
  try {
    const response = await fetch(root.dataset.inventoryUrl, { cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error('Inventory request failed');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const value = doc.querySelector('[data-sg-inventory-total]')?.getAttribute('data-sg-inventory-total');
    if (value == null || !/^\d+$/.test(value)) throw new Error('Inventory count missing');
    const next = Number(value);
    if (!Number.isSafeInteger(next)) throw new Error('Inventory count invalid');
    const first = total === null;
    const changed = next !== total;
    total = next;
    root.dataset.inventory = String(total);
    if (searchCount) searchCount.textContent = format(total) + ' ';
    if (countEl && changed) {
      if (inView) animate(first ? 0 : displayed, total);
      else { displayed = total; countEl.textContent = format(total); }
    }
  } catch (_) {
    if (total === null && countEl) countEl.textContent = '—';
  } finally {
    loading = false;
  }
};
if (counter && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) {
      inView = true;
      if (total !== null) animate(0, total);
      observer.disconnect();
    }
  }, { threshold: 0.25 });
  observer.observe(counter);
} else { inView = true; }
counter?.addEventListener('click', () => {
  if (total !== null) animate(0, total);
  refresh();
});
refresh();
setInterval(refresh, 60000);
document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
window.addEventListener('focus', refresh);
const cards=[...root.querySelectorAll('[data-sg-product]')];if(cards.length>3&&!matchMedia('(prefers-reduced-motion: reduce)').matches){let page=0;setInterval(()=>{page=(page+1)%Math.ceil(cards.length/3);cards.forEach((card,i)=>card.classList.toggle('sg-product-hidden',Math.floor(i/3)!==page));},2000)}
document.addEventListener('click',e=>{const link=e.target.closest('.snize-ac-results a');if(!link)return;const href=link.getAttribute('href');if(href&&href.startsWith('http')){try{const u=new URL(href);if(/myshopify\.com$/.test(u.hostname))link.href=u.pathname+u.search}catch(_){}}},true);})();






(()=>{const grid=document.querySelector('.sg-designer-more-logos');if(!grid)return;const tiles=[...grid.querySelectorAll('a[data-stock][data-tier]')];tiles.sort((a,b)=>Number(a.dataset.tier)-Number(b.dataset.tier)||Number(b.dataset.stock)-Number(a.dataset.stock)||a.textContent.localeCompare(b.textContent));tiles.forEach(tile=>grid.appendChild(tile));})();


